import { Button } from "../atoms/Button.tsx";

interface Props {
  page: number;
  totalPages: number;
  total: number;
  hasMore: boolean;
  onPage: (page: number) => void;
}

/** Server-side pagination controls: count + prev/next + page position. */
export function TablePager({ page, totalPages, total, hasMore, onPage }: Props) {
  return (
    <div className="pager">
      <span className="pager-count">
        {total} {total === 1 ? "item" : "items"}
      </span>
      <div className="pager-nav">
        <Button size="sm" onClick={() => onPage(page - 1)} disabled={page <= 1}>
          Prev
        </Button>
        <span className="pager-pos">
          Page {page} of {totalPages}
        </span>
        <Button
          size="sm"
          onClick={() => onPage(page + 1)}
          disabled={!hasMore || page >= totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
